/**
 * Parses a VBoxContainer through the shared BoxContainer base (Control plus `alignment`). The
 * Control parser collects `theme_override_constants/separation`, and the layout stacks vertically.
 */
import { parseBoxContainer } from '../shared/boxContainer';
export function parseVBoxContainer(heading, properties) {
    return parseBoxContainer(heading, properties);
}
//# sourceMappingURL=parser.js.map